const reviews = [
    { id: 1, 
        review: "Absolutely loving the Ragi Java from this brand! It's become my go-to morning pick-me-up. The rich, nutty flavor and the health benefits make it a win-win for my breakfast routine. Highly recommend!", 
        author: 'Swaroop G',
        img:"https://cdn.pixabay.com/photo/2023/04/23/01/38/ai-generated-7944744_960_720.jpg"
     },
    { id: 2, review: "The variety of soups offered by this brand is fantastic. I tried the Millet and Vegetable Soup, and it's now a staple in my dinner menu. Nutrient-packed and delicious - a great choice for anyone looking to add more wholesome options to their diet.", 
    author: 'Jane Smith',
    img:"https://static.generated.photos/vue-static/face-generator/landing/wall/10.jpg"
 },
    { id: 3, review: "I'm pleasantly surprised by how tasty and filling the Millet Energy Bars are. Perfect for a quick and nutritious snack on busy days. The combination of flavors is spot on, and the energy boost is exactly what I need for my hectic schedule.", 
    author: 'Sowmya A',
    img:"https://cdn.pixabay.com/photo/2023/04/23/01/38/ai-generated-7944744_960_720.jpg"
 },
    { id: 4, review: "As someone always on the lookout for healthy alternatives, the Quinoa and Millet Salad Mix exceeded my expectations. The freshness of the ingredients and the well-balanced flavors make it a delightful addition to my lunch routine. Thumbs up!",
     author: 'Triveni Sharma',
    img:"https://static.generated.photos/vue-static/face-generator/landing/wall/10.jpg" 
},
    { id: 5, review: "The Millet Pancake Mix is a game-changer for breakfast in my household. Quick to prepare, and the texture and taste are top-notch. My family enjoys the wholesome goodness, and I appreciate the effort put into creating such a convenient yet healthy option.",
     author: 'Jhaswin K' ,
      img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWgjCOOazYvYIXWAddif7dGUbDROfE5d5s2A&usqp=CAU"
    },
   

  ];

  export default reviews